import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import Cart from "./Cart";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import CheckedLoggedInModal from "./CheckLoggedInModal";
import toast from "react-hot-toast";
import about1 from "../../assets/images/about1.png";
import "./cart.css";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import LoginPopUp from "../LoginPopup";
import { Tooltip } from "@mui/material";
import { GetProductDetailsBySlug } from "../../ApiServices/SlugsApi/GetProductDetailsBySlugApi";
import { Helmet } from "react-helmet-async";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import OwlCarousel from "react-owl-carousel3";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID } from "../enum";
import ShareLinkModal from "../ShareLinkModal";
const Cart = () => {
  const data = localStorage.getItem("userID");

  console.log(data, "vvvv34");
  const [loginPopUp, setLoginPopUp] = useState(null);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { slug } = useParams();
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const [FAQ, setFaq] = useState([]);
  const [inputValue, setInputValue] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const ItemAddedToast = () => toast.success("Item added successfully");
  const [images, setImages] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const CatID = location?.state?.catId;

  const [productDetailsData, setProductDetailsData] = useState({
    PRODUCT_ID: null,
    PRODUCT_NAME: null,
    PRODUCT_PRICE: null,
    DISCOUNT: null,
    UNIT_ID: 1,
    PRODUCT_DESC: null,
    PRODUCT_SPECI: null,
    UNIT: null,
    CAT_ID: 1,
    CAT_NAME: null,
    CART_ID: 2,
    QUANTITY: null,
    DiscountAmount: 102,
    Length: null,
    Height: null,
    Width: null,
    Weight: null,
    PRODUCT_IMG: null,
    ProductSlug: null,
    MetaTitle: null,
    MetaDescription: null,
    OpenGraphtag: null,
    CanonicalTag: null,
    ExtraMetaTag: null,
    ShortDescription: null,
    KeyFeature: null,
  });
  const { setLoader, loader, activeCategory, setActiveCategory, setIsCartUpdate } =
    useContext(LoaderContext);
  const [blogList, setblogList] = useState([]);

  useEffect(() => {
    // setImages(location?.state?.PRODUCT_IMG);
    GetProductDetailsBySlugData();
  }, []);

  useEffect(() => {

    setImages(location?.state?.PRODUCT_IMG);
    GetProductDetailsBySlugData();
  }, [location]);

  const GetTrendingProducts = (catId, productID) => {
    setLoader(true);
    const data = localStorage.getItem("userID") || "";
    axios
      .get(`${BaseUrl}/GetPopularProduct?CategoryID=${catId}`, {
        START: 1,
        END: 1000000000,
        WORD: "None",
      })
      .then((res) => {
        const responseData = res.data.DATA;
        setLoader(false);
        const filterData = responseData?.filter((prev, index) => prev?.PRODUCT_ID !== productID)

        setblogList(filterData);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (images?.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images?.length);
      }, 5000); // 5 seconds

      return () => clearInterval(interval); // Clear on unmount
    }
  }, [images?.length]);

  const GetProductDetailsBySlugData = async () => {
    // debugger;
    setLoader(true);
    try {
      const response = await GetProductDetailsBySlug(slug);

      if (response) {
        setLoader(false);
        const modalData = response.DATA[0];
        if (!modalData) {
          navigate("/*");
          return;
        }
        console.log(modalData);
        setProductDetailsData(modalData);
        GetTrendingProducts(modalData.CAT_ID, modalData?.PRODUCT_ID);
        GetFAQListByServiceData(modalData?.PRODUCT_ID);

        if (
          location?.state?.PRODUCT_IMG === null ||
          location?.state?.PRODUCT_IMG === undefined
        ) {
          const imagesArray = modalData?.PRODUCT_IMG?.split(',') || [];
          setImages(imagesArray);
          // setImages(modalData?.PRODUCT_IMG);
        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetFAQListByServiceData = async (productID) => {
    // debugger;
    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.EstoreBooking,
        productID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;
        console.log(modalData);
        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // const displayValue = (e) => {
  //     setInputValue(e.target.value);
  // };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
  };
  const handleIncrement = () => {
    if (inputValue < 20) {
      const newValue = inputValue + 1;
      setInputValue(newValue);
      updateProductQuantity(newValue);
    }
  };

  const handleDecrement = () => {
    if (inputValue > 1) {
      const newValue = inputValue - 1;
      setInputValue(newValue);
      updateProductQuantity(newValue);
    }
  };

  // Input change handler
  // const handleInputChange = (e) => {
  //   const filteredValue = e.target.value.replace(/[^0-9]/g, "");

  //   // Handle empty input case
  //   if (filteredValue === "") {
  //     setInputValue(1);
  //     return;
  //   }

  //   const numericValue = parseInt(filteredValue, 10);

  //   // Clamp value between 1-20
  //   const clampedValue = Math.min(Math.max(numericValue, 1), 20);

  //   setInputValue(clampedValue);
  // };

  const handleInputChange = (e) => {
    const filteredValue = e.target.value.replace(/[^0-9]/g, "");
    if (filteredValue === "") {
      setInputValue(1);
      return;
    }
    const numericValue = parseInt(filteredValue, 10);
    const clampedValue = Math.min(Math.max(numericValue, 1), 20);
    setInputValue(clampedValue);
    updateProductQuantity(clampedValue);
  };

  // const addProduct = (product) => {

  //   if (data) {
  //     axios
  //       .post(`${BaseUrl}/Estore_Cart`, {
  //         USER_ID: data,
  //         CART_ID: product?.CAT_ID,
  //         PRODUCT_ID: product?.PRODUCT_ID,
  //         QUANTITY: inputValue,
  //         TASK: "NEW",
  //       })
  //       .then((res) => {
  //         if (res.data.ResponseCode === "0") {
  //           toast.success(res.data.ResponseMessage);
  //           navigate("/view-cart");
  //         } else {
  //           ItemAddedToast();
  //           setTimeout(() => navigate("/view-cart"), 100);

  //           const currentCount = parseInt(localStorage.getItem("cartItemCount")) || 0;
  //           localStorage.setItem("cartItemCount", currentCount + parseInt(inputValue));

  //           // ✅ Dispatch event to update header
  //           window.dispatchEvent(new Event("cartUpdated")); // Notify other components
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error adding product to cart:", error);
  //         alert("An error occurred while adding the item to the cart.");
  //       });
  //   } else {
  //     navigate("/login");
  //     setIsModalOpen(true);
  //   }
  // };

  const addProduct = (product) => {
    if (!isAuthenticated) {
      setLoginPopUp(true);
      return;
    }
    if (data) {
      axios
        .post(`${BaseUrl}/Estore_Cart`, {
          USER_ID: data,
          CART_ID: product?.CAT_ID,
          PRODUCT_ID: product?.PRODUCT_ID,
          QUANTITY: inputValue, // Quantity is only for API, not cart count
          TASK: "NEW",
        })
        .then((res) => {
          if (res.data.ResponseCode === "0") {
            setIsCartUpdate(true)
            toast.success(res.data.ResponseMessage);
            // navigate("/view-cart", { state: { moduleName: "productBooking" } });
          } else {
            ItemAddedToast();
            setTimeout(() => navigate("/view-cart"), 100);
          }

          // ✅ Get existing cart data (array of products)
          let cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

          // ✅ Check if product is already in the cart
          const existingItem = cartItems.find(
            (item) => item.PRODUCT_ID === product.PRODUCT_ID
          );

          if (!existingItem) {
            // ✅ If new, add to cart and update count
            cartItems.push({ PRODUCT_ID: product.PRODUCT_ID });

            // ✅ Save updated cart array
            localStorage.setItem("cartItems", JSON.stringify(cartItems));

            // ✅ Update count in localStorage
            localStorage.setItem("cartItemCount", cartItems?.length);

            // ✅ Notify header to update count
            window.dispatchEvent(new Event("cartUpdated"));
          }
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
          alert("An error occurred while adding the item to the cart.");
        });
    } else {
      navigate("/login");
      setIsModalOpen(true);
    }
  };

  const updateProductQuantity = (quantity) => {
    axios
      .post(`${BaseUrl}/Estore_Cart`, {
        USER_ID: data,
        CART_ID: location.state.CAT_ID,
        PRODUCT_ID: location.state.PRODUCT_ID,
        QUANTITY: quantity,
        TASK: "EDIT",
      })
      .then((res) => {
        console.log(res.data);
        window.dispatchEvent(new Event("cartUpdated"));
      })
      .catch((err) => console.error("Error updating quantity:", err));
  };

  const handleNavigation = (slug) => {

    navigate(`/product-details/${slug}`);

  };
  const options = {
    loop: blogList?.length > 3,
    rewind: true, // Enable rewind instead of looping
    margin: 30,
    nav: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
    smartSpeed: 800,
    navText: [
      "<i class='fas fa-arrow-left'></i>",
      "<i class='fas fa-arrow-right'></i>",
    ],
    responsive: {
      0: {
        items: 1, // 1 item on small screens
      },
      600: {
        items: 2, // 2 items on medium screens
      },
      1000: {
        items: 3, // 3 items on large screens
      },
    },
  };

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };

  const FaqObj = [
    {
      question: "What services does Myomnamo offer?",
      answer:
        "Myomnamo offers a range of spiritual services, including Puja and Darshan bookings. You can book experienced Pandits for rituals or arrange daily pujas. Our E-Store provides access to religious goods, and Puja samgari, puja kits. Additionally, Myom namo offers horoscope services.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a temple visit through My OmNamo?",
      answer:
        "Yes, Myomnamo allows you to book temple visits online for your convenience. You can easily select your preferred temple, date, and time through our app. My Om Namo specializes in offering customized puja packages and online Darshans.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, Myomnamo provides a platform to book personalized consultations with experienced spiritual mentors. You can connect with mentors who can offer guidance and support on your spiritual journey. These sessions can provide personalized advice and practices tailored to your specific needs",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": productDetailsData?.MetaTitle,
    "description": productDetailsData?.MetaDescription,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": productDetailsData?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": productDetailsData?.CannonicalLink
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": productDetailsData?.MetaTitle,
    "description": productDetailsData?.MetaDescription,
    "url": productDetailsData?.CannonicalLink,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Products",
        "item": "https://www.myomnamo.com/my-store"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": productDetailsData?.MetaTitle,
        "item": productDetailsData?.CannonicalLink
      }
    ]
  };


  const productSchema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": productDetailsData.PRODUCT_NAME,
    "image": {
      "@type": "ImageObject",
      "url": (images?.length > 0) ? images[0] : null,
      "width": 524,
      "height": 186
    },
    "description": productDetailsData?.MetaDescription,
    "brand": {
      "@type": "Brand",
      "name": "Myomnamo"
    },
    "sku": "DUSSEHRA-PUJA-KIT-999",
    "productCategory": productDetailsData?.CAT_NAME,
    "offers": {
      "@type": "Offer",
      "url": productDetailsData?.CanonicalTag,
      "priceCurrency": "INR",
      "price": productDetailsData?.PRODUCT_PRICE,
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "12"
    }
  }

  console.log('images', images)
  return (
    <>

      <Helmet>
        <title>{productDetailsData?.MetaTitle}</title>
        <meta
          name="description"
          content={productDetailsData?.MetaDescription}
        />
        <link rel="canonical" href={productDetailsData?.CanonicalTag} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={productDetailsData?.MetaTitle} />
        <meta
          property="og:description"
          content={productDetailsData?.MetaDescription}
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/product-details/${productDetailsData?.ProductSlug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MyOmNamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={productDetailsData?.MetaTitle} />
        <meta
          name="twitter:description"
          content={productDetailsData?.MetaDescription}
        />
        <meta name="twitter:image" content="" />
        {productDetailsData?.ExtraMetaTag}

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      <div className="PujaDetails">
        <div className="PujaDetailsContainer">
          <div className="row">
            {/* Left Side - Sticky Image with Full Utilization */}
            <div className="col-md-5" style={{ maxHeight: '80vh' }}>
              <div
                className="slider-container"
                style={{ overflow: "hidden", width: "100%", height: "85%" }}
              >
                <div
                  className="slider-wrapper"
                  style={{
                    display: "flex",
                    transition: "transform 0.5s ease-in-out",
                    transform: `translateX(-${currentIndex * 100}%)`,
                    height: "100%",
                  }}
                >
                  {Array.isArray(images) && images.length > 0 ? (
                    images.map((image, index) => (
                      <img
                        key={index}
                        src={image || placeholderImg}
                        alt={`Image ${index + 1}`}
                        className="img-fluid rounded"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = placeholderImg;
                        }}
                        style={{
                          width: "100%",
                          height: "80%",
                          objectFit: "contain",
                          flexShrink: 0,
                        }}
                      />
                    ))
                  ) : (
                    <img
                      src={placeholderImg}
                      alt="Image"
                      className="img-fluid rounded"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        flexShrink: 0,
                      }}
                    />
                  )}
                </div>
              </div>
              {images?.length > 1 && (
                <div className=" d-flex gap-3 justify-content-center">
                  <Tooltip title="Previous Image">
                    <button
                      className="input-group-text text-white"
                      style={{ backgroundColor: "#a52444" }}
                      onClick={handlePrev}
                    >
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                  </Tooltip>
                  <Tooltip title="Next Image">
                    <button
                      className="input-group-text text-white"
                      style={{ backgroundColor: "#a52444" }}
                      onClick={handleNext}
                    >
                      <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                  </Tooltip>
                </div>
              )}
            </div>

            {/* Right Side - Scrollable Product Details */}
            <div
              className="col-md-7 d-flex flex-column"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <div className="puja-header">
                <div
                  style={{
                    justifyContent: "end",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  {" "}
                  <button
                    className="pujacustom-btn Normal-app-btn"
                    onClick={() => addProduct(productDetailsData)}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
              <div className="d-flex" style={{ justifyContent: "space-between" }}>
                <div>
                  <h1 >
                    {productDetailsData.PRODUCT_NAME}
                  </h1>
                  <div className="price-tag">
                    <div className="discounted-price">
                      <strong>
                        ₹{" "}
                        {productDetailsData?.PRODUCT_PRICE -
                          Math.round(productDetailsData?.DiscountAmount)}
                      </strong>
                    </div>
                    {productDetailsData?.DISCOUNT !== null &&
                      productDetailsData?.DISCOUNT !== undefined &&
                      Number(productDetailsData?.DISCOUNT) !== 0 ? (
                      <>
                        <span className="original-price">
                          {" "}
                          ₹ {productDetailsData?.PRODUCT_PRICE}
                        </span>
                        <span className="discount-text">
                          ({Math.round(Number(productDetailsData?.DISCOUNT))}%
                          OFF)
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                    <button
                      className=" custom-share-btn"
                      onClick={() => setShowModal(true)}
                      title="Share"
                    >
                      <i className="fa-solid fa-up-right-from-square mx-1"></i>
                      Share
                      {/* Share */}
                    </button>
                  </div>
                </div>
                {/* <div
                className="mt-3 d-flex"
                style={{ justifyContent: "flex-start", height: 'fit-content' }}
              >
               
                <button
                  className="Normal-app-btn "
                  style={{}}
                  onClick={() => addProduct(location.state)}
                >
                  Add to Cart
                </button>
              </div> */}
              </div>

              {/* Size Selection */}

              {/* Product Details */}
              <div className="mt-3">
                <h6>Product Details</h6>

                {/* Dimensions */}
                {productDetailsData.Height ||
                  productDetailsData.Width ||
                  productDetailsData.Length ||
                  productDetailsData.Weight ? (
                  <ul>
                    <h6> Dimensions :</h6>
                    {productDetailsData.Height ? (
                      <p>- Height : {productDetailsData.Height}</p>
                    ) : null}
                    {productDetailsData.Width ? (
                      <p>- Width : {productDetailsData.Width}</p>
                    ) : null}
                    {productDetailsData.Length ? (
                      <p>- Length : {productDetailsData.Length}</p>
                    ) : null}
                    {productDetailsData.Weight ? (
                      <p>- Weight : {productDetailsData.Weight}</p>
                    ) : null}
                  </ul>
                ) : null}

                {/* Short Description */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: productDetailsData?.ShortDescription,
                  }}
                />

                {/* Key Features */}
                {productDetailsData?.KeyFeature !== null &&
                  productDetailsData?.KeyFeature !== undefined ? (
                  <>
                    <h6> Key Features :</h6>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: productDetailsData?.KeyFeature,
                      }}
                    />
                  </>
                ) : (
                  ""
                )}

                {/* Specification  */}
                {productDetailsData.PRODUCT_SPECI !== null &&
                  productDetailsData.PRODUCT_SPECI !== undefined ? (
                  <>
                    <h6> Specifications :</h6>

                    <p
                      dangerouslySetInnerHTML={{
                        __html: productDetailsData.PRODUCT_SPECI,
                      }}
                    />

                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {/* Detailed Description */}
          <div>
            {productDetailsData?.PRODUCT_DESC && <h5> Detailed Description </h5>}
            <div
              dangerouslySetInnerHTML={{
                __html: productDetailsData?.PRODUCT_DESC,
              }}
            />
          </div>

          {/* FAQ section */}
          {FAQ?.length > 0 && (
            <div className="faq-section">
              <section className="faq-one faq-one--page">
                <div
                  className="container"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="sec-title text-center">
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{ perspective: "400px" }}
                    >
                      {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                      {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                      {/* <span className="sec-title__tagline__border"></span> FAQ */}
                    </h6>
                    <h3
                      className="sec-title__title bw-split-in-left"
                      style={{ perspective: "400px" }}
                    >
                      Frequently Asked Questions.
                    </h3>
                  </div>
                  <div className="row">
                    <div className="col-xl-2"></div>
                    <div className="col-xl-8">
                      <div className="faq-one__accordion careox-accordion">
                        {FAQ?.map((faq, index) => (
                          <div
                            key={index}
                            className={`accrodion ${activeIndex === index ? "active" : ""
                              }`}
                            style={{ "--accent-color": faq.color }}
                          >
                            <div
                              className="accrodion-title"
                              onClick={() => toggleFAQ(index)}
                            >
                              <h4>
                                <span
                                  className="accrodion-title__number"
                                  style={{
                                    marginRight: "10px",
                                    fontWeight: "500",
                                  }}
                                ></span>
                                {faq.QUESTION}
                                <span className="accrodion-title__icon"></span>
                              </h4>
                            </div>
                            <div
                              className="accrodion-content"
                              style={{
                                maxHeight: activeIndex === index ? "200px" : "0",
                                overflow: "hidden",
                                transition: "max-height 0.5s ease-in-out",
                              }}
                            >
                              <div className="inner">
                                <p>{faq.ANSWER}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-xl-2"></div>
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* Trending products */}
          <section
            className="blog-section p-1"
            style={{ marginBottom: "50px", backgroundColor: "#f1f6f7" }}
          >
            <div
              className="container mb-0"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center mb-0">
                    {/* <h2>
            {" "}
            <span className="sec-title__tagline__border"></span>Trending Posts
          </h2> */}
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{ perspective: "400px" }}
                    >
                      <img className=" tagline-img" src={batuk} alt="" />
                      Trending Products
                    </h6>
                    <h3
                      className="sec-title__title bw-split-in-left"
                      style={{ perspective: "400px" }}
                    >
                      Products
                    </h3>
                    {/* <p>Stay updated with our latest news and insights</p> */}
                  </div>

                  <OwlCarousel className="owl-theme" {...options}>
                    {blogList && blogList?.length > 0 ? (
                      blogList?.map((item, index) =>
                        item ? (
                          <div
                            onClick={() => handleNavigation(item?.ProductSlug)}
                          >
                            <div
                              className="card-custom trending-products-cards"
                              key={item?.ROW || index}
                              style={{ height: "400px" }}
                            >
                              <div className="card-custom__header">
                                <img
                                  src={
                                    item?.PRODUCT_IMG === null
                                      ? placeholderImg
                                      : item?.PRODUCT_IMG?.split(",")[0]
                                  }
                                  alt={item?.PRODUCT_NAME}
                                  style={{ objectFit: "contain" }}
                                  className="card-custom__image mt-1"
                                />
                              </div>
                              <div className="card-custom__body">
                                <h4 className="service-two__item__title">
                                  {item?.PRODUCT_NAME}
                                </h4>
                                <p className="card-text text-muted small">
                                  {stripHtml(item?.PRODUCT_DESC)?.length > 80
                                    ? `${stripHtml(item?.PRODUCT_DESC).substring(
                                      0,
                                      80
                                    )}...`
                                    : stripHtml(item?.PRODUCT_DESC)}
                                </p>
                              </div>
                              <div className="prod-details d-flex align-items-center flex-column">

                                <span
                                  style={{
                                    whiteSpace: "nowrap",
                                    color: "#a52444",
                                    fontSize: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                  }}
                                >
                                  View Details <i className="icon-right-arrow"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : null
                      )
                    ) : (
                      <p className="text-center">No Products available</p>
                    )}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
      <ShareLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        shareUrl={currentUrl}
        message="Hey! Have a look at this amazing content." // Optional
        title="Spread the word" // Optional
      />

    </>
  );
};

export default Cart;
